import {
    AnimationBaseController,
    GameRandom,
} from "../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../modules/@denishussar/html5-game-engine";
import { AnimationContents } from "../AnimationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { BgFloorTileContainerModel } from "../../Models/BgContainerModels/BgFloorTileContainerModel";
import { BgSimpleTileController, IBgSimpleTileControllerOptions } from "./BgTiles/BgSimpleTileController";

export interface IBgSimpleTileContainerControllerOptions {
    tileName: string
}

export class BgSimpleTileContainerController extends AnimationBaseController {
    $model: BgFloorTileContainerModel;

    public constructor(@Inject private _options: IBgSimpleTileContainerControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("BgSimpleTileContainerController");
        console.log('BgSimpleTileContainerController: ', this._options.tileName, this);


    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: "bg_tile_container",
            childControllers: {

            }
        };
    }

    protected onInitialize(): void {
        this.$model.tiles.forEach((tileModel, i) => {
            this.addChildController({
                model: tileModel,
                controller: BgSimpleTileController,
                options: <IBgSimpleTileControllerOptions>{
                    libraryName: this._options.tileName
                }
            }, `Tile-${i}`);
        });
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
}

